'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import React from 'react';
const Passthrough = ({ children }) => children;
const DynamicComputerFileUploadUpsellPopover = Dynamic(async () => {
    const { ComputerFileUploadUpsellPopover } = await import('#pplx/frontend/apps/ask/computer-file-upload-upsell/ComputerFileUploadUpsellPopover.js');
    return { default: ComputerFileUploadUpsellPopover };
}, { loading: Passthrough });
export const ComputerFileUploadUpsellBoundary = React.memo(function ComputerFileUploadUpsellBoundary(props) {
    const { isMobileStyle } = useIsMobile();
    if (isMobileStyle || !props.attachments.length)
        return props.children;
    return _jsx(DynamicComputerFileUploadUpsellPopover, { ...props });
});
//# sourceMappingURL=ComputerFileUploadUpsellBoundary.js.map